import React, { CSSProperties } from 'react';
import { DraggableObject, MoveSpellobject } from '../../reducers/drag/dragReducer';
import SpellRender from './SpellRender';

interface DragSpellProps {
    dragInfo: DraggableObject,
    style: CSSProperties,
}

const DragSpell = ({
    style,
    dragInfo,
}: DragSpellProps) => {
    const info = dragInfo as MoveSpellobject;
    return (
        <SpellRender
            style={style}
            shape={info.details.shape}
            className='absolute pointer-events-none'
        />
    );
};

export default DragSpell;
